// only keeping this section as reference of the latest format of the taxonomy file
export const TransunionTaxonomy = `168018,Dun and Bradstreet,B2B Job Function/Roles,Other > Designer,People working as designers. Created by Dun & Bradstreet.,1.5
168023,Gravy Analytics,B2B,Graphic Design,Mobile users that have attended B2B events and venues related to Graphic Design,2.5
168024,33Across,B2B,Photographer,Functional Area > Photographer,2.0
168032,SMS,Occupation,Occupation: White Collar Worker: Graphic Designer/Commercial Art,Contains Individuals with Occupation: White Collar Worker: Graphic Designer/Commercial Art,1.75
168033,Bombora,B2B,B2B Interest Groups > Marketing > Creativity Software,"Business professionals interested in creativity software, in areas such as graphic design and copywriting.",2.1
168010,Bombora,B2B,"B2B Interest Groups > Technology > Graphics, Multimedia & Web Design","Business professionals interested in graphics, multimedia and web design, in areas such as website performance and web services.",2.1`;

export interface ITransunionNode {
  children: ITransunionNode[];
  value: string;
  data: ITransunionData | undefined | null;
}

export interface ITransunionData {
  ID: string;
  Meta1: string;
  Meta2: string;
  Name: string[];
  Description: string;
  Price: string;
}

export function parseTransunionData(customDataStore: string): ITransunionData[] {
  const TransunionDataSet = new Set('');
  const dedupTransunionData: ITransunionData[] = [];
  const dataArray = customDataStore.split('\n');
  dataArray
    .filter((d: string) => d !== '')
    .forEach((d: string) => {
      const data = d.split(',');
      let name = data[3];
      let description = data[4];
      // name and description might contain coma, which would break the info extraction.
      // for those items, it will be wrapped with quote
      // such as: 168010,Bombora,B2B,"B2B Interest Groups > Technology > Graphics, Multimedia & Web Design","Business professionals interested in graphics, multimedia and web design, in areas such as website performance and web services.",2.1
      // in that case, we need to find out the item start with " and end with " and join them to become the real name and description
      if (data.length > 6) {
        if (data[3].startsWith('"')) {
          let idx = 3;
          for (; idx < data.length - 1; idx++) {
            if (data[idx].endsWith('"')) {
              name = data.slice(3, idx + 1).join(',');
              break;
            }
          }
          description = data.slice(idx + 1, data.length - 1).join(',');
        } else {
          description = data.slice(4, data.length - 1).join(',');
        }
      }
      // if name contains quote, remove them
      if (name.startsWith('"')) {
        name = name.substring(1, name.length - 1);
      }
      // if description contains quote, remove them
      if (description.startsWith('"')) {
        description = description.substring(1, description.length - 1);
      }
      const TransunionData: ITransunionData = {
        ID: data[0] || '',
        Meta1: data[1] || '',
        Meta2: data[2] || '',
        Name: name.split(' > ') || ([] as string[]),
        Description: description || '',
        Price: data[data.length - 1] || '',
      };

      if (TransunionData.ID !== '' && !TransunionDataSet.has(TransunionData.ID)) {
        TransunionDataSet.add(TransunionData.ID);
        dedupTransunionData.push(TransunionData);
      }
    });

  return dedupTransunionData;
}

export function parseTransunionTree(rawData: ITransunionData[]): ITransunionNode[] {
  const TransunionTree = [] as ITransunionNode[];
  for (const d of rawData) {
    let currentLevel = TransunionTree;
    for (let i = 0; i < d.Name.length; i += 1) {
      if (currentLevel.length === 0) {
        const newNode: ITransunionNode = Object.assign(
          {
            children: [] as ITransunionNode[],
            value: d.Name[i],
          },
          i === d.Name.length - 1 ? { data: d } : { data: undefined },
        );
        currentLevel.push(newNode);
        if (i !== d.Name.length - 1) {
          currentLevel = newNode.children;
        }
      } else {
        for (let j = 0; j < currentLevel.length; j += 1) {
          if (currentLevel[j].value === d.Name[i]) {
            currentLevel = currentLevel[j].children;
            break;
          } else {
            if (j === currentLevel.length - 1) {
              const newNode: ITransunionNode = Object.assign(
                {
                  children: [] as ITransunionNode[],
                  value: d.Name[i],
                },
                i === d.Name.length - 1 ? { data: d } : { data: undefined },
              );
              currentLevel.push(newNode);
              if (i !== d.Name.length - 1) {
                currentLevel = newNode.children;
              }
            }
          }
        }
      }
    }
  }

  return TransunionTree;
}
